import { render, staticRenderFns } from "./Modules.vue?vue&type=template&id=8515fefc&scoped=true&"
import script from "./Modules.vue?vue&type=script&lang=js&"
export * from "./Modules.vue?vue&type=script&lang=js&"
import style0 from "./Modules.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Modules.vue?vue&type=style&index=1&id=8515fefc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8515fefc",
  null
  
)

export default component.exports